
import { PageHeader } from "@/components/PageHeader";
import { SharedKanbanBoard } from "@/components/jobs/kanban/SharedKanbanBoard";

const Kanban = () => {
	return (
		<div className="h-full overflow-hidden flex flex-col">
			<PageHeader title="Recruitment Pipeline" />
			
			<div className="flex-1 overflow-auto p-4 w-full">
				{/* Display all matches across jobs in kanban view */}
				<SharedKanbanBoard showAllMatches={true} />
			</div>
		</div>
	);
};

export default Kanban;
